import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPandoraApp = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={100} height={100} fill="currentColor" viewBox="0 0 50 50" {...props}>
        <path d="M10 6a1 1 0 0 0-1 1v36a1 1 0 0 0 1 1h8c1.645 0 3-1.355 3-3v-6h6.12c7.78 0 14.497-5.991 14.864-13.8C42.376 12.89 35.728 6 27.5 6H10zm1 2h16.5a12.483 12.483 0 0 1 12.486 13.105C39.67 27.818 33.876 33 27.12 33H20a1 1 0 0 0-1 1v7c0 .565-.435 1-1 1h-7V8z" />
    </svg>
);
export default SvgPandoraApp;
